module.exports = __webpack_public_path__ + "img/help_other_x@3x.eaecf67f.png";